import React, { ReactElement } from 'react';
interface IRoundPrimaryIconProps {
  customStyle?: any;
  fill: string;
  onClick?: () => void;
}

const RoundPrimaryIcon = ({ customStyle, fill = '#C9C9C9', ...rest }: IRoundPrimaryIconProps): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      style={customStyle}
      {...rest}
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <mask
        id="mask0_10230_4947"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="32"
        height="32"
      >
        <rect x="8" y="8" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10230_4947)">
        <path
          d="M23.9935 31.311C25.1831 31.311 26.3057 31.0574 27.361 30.5502C28.4163 30.0429 29.2725 29.3012 29.9295 28.3251C30.1588 28.0069 30.1894 27.6768 30.0213 27.335C29.8532 26.9931 29.5894 26.8222 29.23 26.8222C29.0177 26.8222 28.8292 26.8715 28.6645 26.9702C28.4998 27.0689 28.3488 27.195 28.2116 27.3483C27.7142 27.9882 27.0954 28.4773 26.3554 28.8156C25.6154 29.154 24.8365 29.3231 24.0186 29.3231C23.2008 29.3231 22.419 29.1614 21.6733 28.8379C20.9276 28.5144 20.3064 28.0252 19.8097 27.3705C19.6841 27.2172 19.5346 27.0875 19.3613 26.9813C19.1879 26.8752 18.9989 26.8222 18.7943 26.8222C18.434 26.8222 18.1793 27.0044 18.0301 27.3688C17.8809 27.7332 17.9273 28.0877 18.1691 28.4323C18.8292 29.3882 19.6741 30.1069 20.7038 30.5886C21.7336 31.0702 22.8301 31.311 23.9935 31.311ZM28.674 22.5033C29.226 22.5033 29.696 22.3093 30.0841 21.9212C30.4722 21.5331 30.6662 21.0631 30.6662 20.511C30.6662 19.959 30.4722 19.489 30.0841 19.1009C29.696 18.7128 29.2239 18.5188 28.6677 18.5188C28.1241 18.5188 27.6603 18.7134 27.2764 19.1026C26.8925 19.4917 26.7005 19.9607 26.7005 20.5096C26.7005 21.0584 26.8921 21.5279 27.2753 21.918C27.6585 22.3082 28.1248 22.5033 28.674 22.5033ZM19.3315 22.5033C19.8751 22.5033 20.3389 22.3087 20.7228 21.9195C21.1067 21.5303 21.2986 21.0613 21.2986 20.5125C21.2986 19.9637 21.107 19.4942 20.7238 19.104C20.3406 18.7139 19.8744 18.5188 19.3252 18.5188C18.7732 18.5188 18.3031 18.7128 17.915 19.1009C17.5269 19.489 17.3329 19.959 17.3329 20.511C17.3329 21.0631 17.5269 21.5331 17.915 21.9212C18.3031 22.3093 18.7753 22.5033 19.3315 22.5033ZM24.0013 37.8608C22.0845 37.8608 20.2836 37.4993 18.5986 36.7763C16.9136 36.0532 15.4439 35.0645 14.1894 33.8101C12.935 32.5557 11.9463 31.0865 11.2232 29.4026C10.5002 27.7188 10.1387 25.9184 10.1387 24.0017C10.1387 22.0849 10.5002 20.284 11.2232 18.599C11.9463 16.9139 12.9343 15.444 14.1874 14.1891C15.4406 12.9342 16.9093 11.9434 18.5938 11.2166C20.2783 10.4899 22.0793 10.1265 23.9968 10.1265C25.9143 10.1265 27.716 10.4895 29.402 11.2157C31.0881 11.9418 32.5582 12.9317 33.8124 14.1855C35.0667 15.4393 36.057 16.9088 36.7834 18.5942C37.5098 20.2796 37.873 22.0815 37.873 23.9999C37.873 25.9179 37.5097 27.7193 36.7829 29.4042C36.0561 31.0891 35.0653 32.5582 33.8104 33.8116C32.5555 35.065 31.0861 36.0533 29.4023 36.7763C27.7184 37.4993 25.9181 37.8608 24.0013 37.8608Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default RoundPrimaryIcon;
